import React from 'react';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { FIELD_VIEW_URL } from 'constants/urls';

const baseString = 'no-fields';

export const NoFieldsActions = () => {
  return (
    <div className={baseString}>
      <Button mode='secondary' onClick={() => window.location.assign(FIELD_VIEW_URL.FIELD_SELECTION)}>
        {getMessage('button-text__create-fields')}
      </Button>
      <Button mode='secondary' onClick={() => window.location.assign(FIELD_VIEW_URL.DATA_INBOX)}>
        {getMessage('button-text__upload-fields')}
      </Button>
    </div>
  );
};
